(function () {
    'use strict';

    angular
        .module('app')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = ['API', 'helpers', 'alert',];

    function DashboardController(API, helpers, alert) {
        var vm = this;

        vm.loadingState = {
            subscribers: false,
            activeUsersPerDay: false,
            unverifiedSchools: false,
            subscribersPerDay: false,
            latestRegistrations: false,
            usersWithoutGroups: false,
        };

        vm.activeUsersPerDay = {
            labels: [],
            data: [],
        };
        vm.newSubscribersPerDay = {
            labels: [],
            data: [],
        };

        vm.latestChanges = [];
        vm.latestComments = [];
        vm.latestConversions = [];
        vm.latestRegistrations = [];
        vm.latestOrders = [];
        vm.subscribers = [];
        vm.totalUnverifiedSchools = 0;
        vm.totalUsersWithoutGroups = 0;

        vm.seeChanges = seeChanges;


        activate();

        function activate() {
            loadLatestComments();
            loadLatestChanges();
            loadUnverifiedSchools();
            loadUsersWithoutGroups();
            loadLatestRegistrations();
            loadNewSubscribersPerDay();
            loadSubscribers();
            loadStatisticsActiveUsersPerDay();
        }


        function seeChanges(log) {
            alert.open('log-changes', { changes: helpers.printObject(log.changes) });
        }

        function loadLatestComments() {
            vm.loadingState.latestComments = true;

            var promise = API.AdminComments.get({ expand: 'user', sort: '-created', 'per-page': 5 }).$promise;
            promise.then(function (response) {
                angular.forEach(response.items, function(item) {
                    if (item.comment.length >= 100) {
                        item.comment = item.comment.substring(0, 100);
                        item.comment += '...';
                    }
                    vm.latestComments.push(item);
                });
            }, function () {})
            .finally(function() {
                vm.loadingState.latestComments = false;
            });
        }

        function loadLatestChanges() {
            vm.loadingState.latestChanges = true;

            var promise = API.AdminLogs.get({ expand: 'user', sort: '-created', 'per-page': 5 }).$promise;
            promise.then(function (response) {
                angular.forEach(response.items, function(item) {
                    vm.latestChanges.push(item);
                });
            }, function () {})
            .finally(function() {
                vm.loadingState.latestChanges = false;
            });
        }
        function loadLatestRegistrations() {
            vm.loadingState.latestRegistrations = true;

            var promise = API.Statistic.query({ action: 'latest-registrations' }).$promise;
            promise.then(function (response) {
                angular.forEach(response, function(item) {
                    vm.latestRegistrations.push(item);
                });
                vm.loadingState.latestRegistrations = false;
            }, function () {
                vm.loadingState.latestRegistrations = false;
            });
        }

        function loadNewSubscribersPerDay() {
            vm.loadingState.subscribersPerDay = true;

            API.Statistic.query({ action: 'new-subscribers-per-day' }).$promise.then(function (response) {
                angular.forEach(response, function (day) {
                    vm.newSubscribersPerDay.labels.push(day.date);
                    vm.newSubscribersPerDay.data.push(day.count);
                });
                vm.loadingState.subscribersPerDay = false;
            }, function () {
                vm.loadingState.subscribersPerDay = false;
            });
        }

        function loadUnverifiedSchools() {
            vm.loadingState.unverifiedSchools = true;

            API.School.search({ status: 'unverified', fk_third_party_entity_id: 'null', 'per-page': 10 }).$promise.then(function (response) {
                if (response.items) {
                    vm.unverifiedSchools = response.items;
                }
                vm.totalUnverifiedSchools = response._meta.totalCount;
                vm.loadingState.unverifiedSchools = false;
            }, function () {
                vm.loadingState.unverifiedSchools = false;
            });
        }

        function loadUsersWithoutGroups() {
            vm.loadingState.usersWithoutGroups = true;

            API.User.search({
                groups__id: '',
                'per-page': 10,
                user_type: 'parent,teacher,student,child'
            }).$promise.then(function (response) {
                if (response.items) {
                    vm.usersWithoutGroups = response.items;
                }
                vm.totalUsersWithoutGroups = response._meta.totalCount;
                vm.loadingState.usersWithoutGroups = false;
            }, function () {
                vm.loadingState.usersWithoutGroups = false;
            });
        }

        function loadStatisticsActiveUsersPerDay() {
            vm.loadingState.activeUsersPerDay = true;

            API.Statistic.query({ action: 'active-users-per-day' }).$promise.then(function (response) {
                angular.forEach(response, function (day) {
                    vm.activeUsersPerDay.labels.push(day.date);
                    vm.activeUsersPerDay.data.push(day.count);
                });
                vm.loadingState.activeUsersPerDay = false;
            }, function () {
                vm.loadingState.activeUsersPerDay = false;
            });
        }

        function loadSubscribers() {
            vm.loadingState.subscribers = true;
            API.Statistic.query({ action: 'subscribers' }).$promise.then(function (response) {
                vm.subscribers = response;
                vm.loadingState.subscribers = false;
            }, function () {
                vm.loadingState.subscribers = false;
            });
        }


    }
})();